<template>
  <DialogPrime
    v-model:visible="localVisible"
    :modal="true"
    :dismissable-mask="false"
    :closable="false"
    style="width: 900px; max-width: 95vw;"
  >
    <template #header>
      <div class="d-flex justify-content-between align-items-center w-100 me-0">
        <span class="fw-semibold">MCR Item Note</span>
        <ButtonPrime label="Add Note" icon="pi pi-plus" size="small" @click="addNote" />
      </div>
    </template>

    <DataTable :value="notes" class="p-datatable-sm" style="min-width: 400px;">
      <template #empty>
        <div class="text-center text-muted py-3">No notes yet. Click "Add Note" to add one.</div>
      </template>
      <Column header="Notes">
        <template #body="{ data }">
          <PrimeTextarea
            v-model="data.notes"
            :rows="2"
            :disabled="isNoteLocked(data)"
            style="width: 100%;"
          />
        </template>
      </Column>
      <Column header="Created By" style="width: 150px;">
        <template #body="{ data }">
          <span style="font-size: 0.85rem;">{{ data.user_created?.name || data.created_by || '-' }}</span>
        </template>
      </Column>
      <Column header="Created At" style="width: 130px; white-space: nowrap;">
        <template #body="{ data }">
          <span class="text-muted" style="font-size: 0.8rem;">{{ formatDate(data.created_at) }}</span>
        </template>
      </Column>
      <Column header="" style="width: 50px; text-align: center;">
        <template #body="{ data }">
          <ButtonPrime
            icon="pi pi-trash"
            text
            rounded
            severity="danger"
            size="small"
            :disabled="isNoteLocked(data)"
            @click="removeNote(data)"
          />
        </template>
      </Column>
    </DataTable>

    <template #footer>
      <ButtonPrime label="Close" outlined @click="localVisible = false" />
      <ButtonPrime label="Save Notes" icon="pi pi-save" :loading="onSave" @click="saveNotes" />
    </template>
  </DialogPrime>
</template>

<script>
import api from "@/helpers/api";
import cataloguerFormService from '@/services/materialCatalogingRequest/cataloguerFormService';

export default {
  name: "AddNoteItemModal",
  props: {
    visible: { type: Boolean, default: false },
    item: { type: Object, default: null },
  },
  emits: ["update:visible", "saved"],
  data() {
    return {
      notes: [],
      onSave: false,
    };
  },
  computed: {
    localVisible: {
      get() { return this.visible; },
      set(val) { this.$emit("update:visible", val); },
    },
    currentUsername() {
      return this.$store.state.auth.user?.namecode || '';
    },
  },
  watch: {
    visible(val) {
      if (val) {
        this.notes = (this.item?.emcr_item_note || []).map(n => ({ ...n }));
      }
    },
  },
  methods: {
    isNoteLocked(data) {
      const cancelNotePrefix = 'This MCR Item has been canceled because';
      const uncancelNotePrefix = 'This MCR Item has been uncanceled because';
      const duplicatedNotePrefix = 'This MCR Item has been marked as a duplicate because';
      const unDuplicateNotePrefix = 'This MCR Item has been unmarked as a duplicate because';
      const isPendingCancelNote = ((data.notes || '').startsWith(cancelNotePrefix) || (data.notes || '').startsWith(uncancelNotePrefix)) && data.status === null;
      const isPendingDuplicateNote = ((data.notes || '').startsWith(duplicatedNotePrefix) || (data.notes || '').startsWith(unDuplicateNotePrefix)) && data.status === null;
      return data.status === '1' || isPendingCancelNote || isPendingDuplicateNote;
    },
    addNote() {
      this.notes.push({
        id: null,
        mcr_item_code: this.item?.mcr_item_code || '',
        notes: '',
        status: null,
        created_by: this.currentUsername,
        updated_by: this.currentUsername,
        created_at: null,
        updated_at: null,
      });
    },
    formatDate(value) {
      if (!value) return '-';
      const d = new Date(value);
      if (isNaN(d)) return value;
      const months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
      const pad = n => String(n).padStart(2, '0');
      return `${d.getDate()} ${months[d.getMonth()]} ${d.getFullYear()}, ${pad(d.getHours())}:${pad(d.getMinutes())}`;
    },
    removeNote(data) {
      const idx = this.notes.indexOf(data);
      if (idx > -1) this.notes.splice(idx, 1);
    },
    async saveNotes() {
      if (!this.item) return;
      this.onSave = true;
      try {
        const respons = await api(this, cataloguerFormService.saveNoteItem(this.item.mcr_item_code, { action: 'update_notes', emcr_item_note: this.notes }));
        this.$emit('saved', { mcr_item_code: this.item.mcr_item_code, notes: Array.isArray(respons.data) ? respons.data : [...this.notes] });
        this.localVisible = false;
      } catch (error) {
        const status = error?.response?.status;
        const serverMsg = error?.response?.data?.message || error?.response?.data?.error;
        const detail = serverMsg || error?.message || 'Unknown error';
        const summary = status ? `Error ${status}` : 'Error';
        this.$toastNotifPrime('error', summary, detail);
      } finally {
        this.onSave = false;
      }
    },
  },
};
</script>
